import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import CourseRating from "../../../models/course-rating.model";
import ReportSpam from "../../../models/report-spam.model";

@Component({
  selector: "ngx-view-rating",
  styleUrls: ["./view-rating.component.scss"],
  templateUrl: "./view-rating.component.html",
})
export class ViewRatingComponent {
  @Input() rating: CourseRating;
  @Input() mode?: string;
  @Output() onDeleteRating: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();

  submitted = false;
  loading = false;

  constructor(private dialogService: NbDialogService) {}

  deleteRating() {
    this.onDeleteRating.emit(this.rating);
  }

  report(item: ReportSpam) {
    this.onDelete.emit(this.rating);
  }
}
